<style scoped="scoped">
  *{
    margin:0;
    padding: 0;
  }
  .cloudSupplierBox{
    /* width:1120px; */
    height:auto;
    margin:25px 50px auto 50px;
    text-align: left;
    background: #F8F8F8;
    /* background-color: rgb(109, 109, 109); */
    
  }
  .cloudSupplierBtnList{
    margin-top: -30px;
    display: flex;
    flex-wrap: wrap;
    /* justify-content: space-between; */
    /* background-color: rosybrown; */
    box-sizing: border-box;
  }
  
  .cloudSupplierBtn{
    width:200px;
    height:240px;
    margin-top: 60px;
    background: #FCFCFC;
    border: 2px solid #FCFCFC;
    border-radius: 15px;
    cursor: pointer;
    box-shadow: 0px 5px 20px rgba(151, 151, 151, 0.16);
    margin-right: 67px;
    z-index: 99;
    box-sizing: border-box;

  }
  .cloudSupplierBtn:nth-child(4n){
    margin-right: 0px;
  }
   .cloudSupplierBtn:hover{
    border: 2px solid #6376f7;
    background: #ffffff;
  }
  .cloudSupplierBtn:hover>p{
    color: #6376F7;
  }
  /* .cloudSupplierBtn:last-child{
    margin-bottom: 0px;
  } */

  .cloudSupplierBtn i{
    margin:54px auto 0px;
    display: block;
    font-size: 120px;
    color:#333333;
    text-align: center;
  }
  .cloudSupplierBtn p{
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: #333333;
    margin-top: 10px;
    
    

  }
  .cloudSupplierBottomBox{
    margin-top:130px;
    height:20px;
    width:100%;
    color:#191919;
    font-size: 14px;
    padding:0 30px;
    margin-bottom: 70px;
  }
  .cloudWork{
    font-size: 23px;
    font-weight: bold;
    color: #4d4d4d;
    font-family: PingFang SC;
  }
  .welcomeUser{
    /* margin-left: 17px; */
    font-size: 16px;
    font-weight: 400;
    color: #666666;
  }
  .welcomeUser_1{
    font-size: 13px;
    color: #B7B7B7;
    /* margin-left: 18px; */
  }
  .cloudSupplierTitle{
    display: flex;
    justify-content: space-between;
  }
  .cloudSupplierTitle_left{
    display: inline-block;
  }
  .cloudSupplierTitle_right{
    /* display: inline-block; */
    display: flex;
  }
  .backStage{
    font-size: 23px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #B7B7B7;
    opacity: 0.24;
    position: relative;
    top: -12px;
  }
  .itemImg{
    width: 100px;
    height: 100px;
    margin:40px auto 0px;
    display: block;
    color:#666666;
    text-align: center;
  }
  .drawingImg{
    width: 349px;
    height: 261px;
    position: absolute;
    top: 780px;
    right: 240px;
  }
 .guiguiFunNav{
   display: flex;
   align-items: center;
   justify-content: center;
   margin-top: 20px;
 }
 .guiguiFunNavItem{
    line-height: 32px;
    margin-right:25px;
    cursor: pointer;
    width: 120px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 4px;
    text-align: center;
 }
 .guiguiFunNavItem:hover{
    border:1px solid rgb(99, 118, 247);
  }

 
</style>

<template>
  <div class='cloudSupplierBox'>
    <div class="cloudSupplierTitle">
        <p class='cloudSupplierTitle_left'>
        <!-- <span class="cloudWork">云仓工作台</span>  -->
        <span class="welcomeUser">
          <span>角色：{{role}}，</span>
          <span  class="welcomeUser_1" v-if="!mode" >{{saveMySupplierInfo.name}}您好</span>
          <span v-else>{{saveMyUserInfo.name}}，您好</span>
        </span>
      </p>
      <div class="cloudSupplierTitle_right">
        <!-- <span style="color:#6376F7;cursor: pointer;" v-if="!mode" @click="toCloudMall">前台商城</span> -->
        <span @click='toAdministrator' style="color:#6376F7;cursor: pointer;margin-left:48px">进入管理员后台</span>
      </div>
    </div>
    <!-- <span class="backStage">Backstage</span>   -->
    <div class="guiguiFunNav">
      <div class="guiguiFunNavItem" :style='nowGuiguiFun==item ? "border:1px solid rgb(99, 118, 247);background:rgb(99, 118, 247);color:#fff;":"boxShadow: 0px 3px 6px rgba(119, 119, 119, 0.16);"' v-for="(item,index) in guiguiGunList" :key="index" @click="changeFunNav(item)">{{item}}</div>
    </div>
    <div class='cloudSupplierBtnList'>
      
      <div class='cloudSupplierBtn' v-for='(item,index) in nowManageList' :data-index='index' 
        :key="item.name" @click='item.func' @mouseenter="changeImg" @mouseleave="backImg">
          <!-- <i :class='item.icon'></i> -->
          <img :src="item.hover?item.iconChange:item.icon" class="itemImg itemIconChange" >
          <p class="itemNameChange">{{item.name}}</p>
      </div>
      <span>
      <!-- <img src="../../assets/iconList/inOffice@2x.png" class="drawingImg" alt=""> -->
    </span>
    </div>
    <!-- <p class='cloudSupplierBottomBox'> -->
      <!-- <span @click='toQuotation' style="color:#0404fe;cursor: pointer;">报价单({{price_count}})</span> -->
      <!-- <span style="margin-left:150px">保证金:{{supplierInfo.deposit}}元<span @click='dev' style="color:#0404fe;cursor: pointer;margin-left:20px">充值</span></span> -->
      <!-- <span @click='dev' style="color:#0404fe;cursor: pointer;margin-left:150px">赔付记录<i class='el-icon-arrow-right'></i></span> -->
      <!-- <span @click='toAdministrator' style="color:#0404fe;cursor: pointer;margin-left:150px">进入管理员后台<i class='el-icon-arrow-right'></i></span> -->
    <!-- </p> -->
  </div>
</template>

<script>
  import { mapMutations, mapState, mapGetters } from "vuex";
	export default {
		components:{

		},
		props:[],
		data() {
			return {
        data:{},
        nowGuiguiFun:'基础办公',
        guiguiGunList:["基础办公","车间管理","全面运营"],
        cloudSupplierBtnList:[{
            name:"销售订单",
            icon:require("../../assets/iconList/order@2x.png"),
            iconChange:require("../../assets/iconList/orderChange@2x.png"),
            func:this.toQueryOrderSeller
          },{
            name:"采购订单",
            icon:require("../../assets/iconList/purchase@2x.png"),
            iconChange:require("../../assets/iconList/purchaseChange@2x.png"),
            func:this.toQueryOrderBuyer
          },{
            name:"仓库管理",
            icon:require("../../assets/iconList/warehouse@2x.png"),
            iconChange:require("../../assets/iconList/warehouseChange@2x.png"),
            func:this.toStoreManage
          },{
            name:"设计方案",
            icon:require("../../assets/iconList/icon_design@2x.png"),
            iconChange:require("../../assets/iconList/icon_design_s-01@2x.png"),
            func:this.toDesignOrder
          },{
            name:"商品管理",
            icon:require("../../assets/iconList/goodsManage@2x.png"),
            iconChange:require("../../assets/iconList/goodsManageChange@2x.png"),
            func:this.toGoodsManage
          },{
            name:"客户资料",
            icon:require("../../assets/iconList/customerInfo@2x.png"),
            iconChange:require("../../assets/iconList/customerInfoChange@2x.png"),
            func:this.toClientManage
          },{
            name:"员工管理",
            icon:require("../../assets/iconList/staffManage@2x.png"),
            iconChange:require("../../assets/iconList/staffManageChange@2x.png"),
            func:this.toStaffManage
          },{
            name:"财务管理",
            icon:require("../../assets/iconList/financialManage@2x.png"),
            iconChange:require("../../assets/iconList/financialManageChange@2x.png"),
            func:this.toFinancialManage
          },
          {
            name:"我的供应商",
            icon:require("../../assets/iconList/supplier@2x.png"),
            iconChange:require("../../assets/iconList/supplierChange@2x.png"),
            func:this.toSupplierManage
          },
          {
            name:"颜色管理",
            icon:require("../../assets/iconList/colour_01@2x.png"),
            iconChange:require("../../assets/iconList/colour_s_01@2x.png"),
            func:this.toColorCardManage
          },{
            name:"会员系统",
            icon:require("../../assets/iconList/vip@2x.png"),
            iconChange:require("../../assets/iconList/vipChange@2x.png"),
            func:this.toVipSystem
          },

        ],
        workShopManageList:[
          {
            name:"分拣打包",
            icon:require("../../assets/iconList/icon_pack_n@2x.png"),
            iconChange:require("../../assets/iconList/icon_pack_s@2x.png"),
            func:this.toPacking
          },{
            name:"生产车间",
            icon:require("../../assets/iconList/icon_speedofprogress_n@2x.png"),
            iconChange:require("../../assets/iconList/icon_speedofprogress_s@2x.png"),
            func:this.toProductOrder
          },{
            name:"成品仓库",
            icon:require("../../assets/iconList/icon_warehouse_n@2x.png"),
            iconChange:require("../../assets/iconList/icon_warehouse_s@2x.png"),
            func:this.dev
          },{
            name:"智能跟单",
            icon:require("../../assets/iconList/icon_documentary_n@2x.png"),
            iconChange:require("../../assets/iconList/icon_documentary_s@2x.png"),
            func:this.dev
          },
        ],
        overAllPperationList:[
          {
            name:"前台商城",
            icon:require("../../assets/iconList/icon_mall_n@2x.png"),
            iconChange:require("../../assets/iconList/icon_mall_s@2x.png"),
            func:this.toShop
          },{
            name:"成本计算器",
            icon:require("../../assets/iconList/icon_calculator_n@2x.png"),
            iconChange:require("../../assets/iconList/icon_calculator_s@2x.png"),
            func:this.dev
          },{
            name:"销量统计",
            icon:require("../../assets/iconList/icon_salesvolume_n@2x.png"),
            iconChange:require("../../assets/iconList/icon_salesvolume_s@2x.png"),
            func:this.dev
          },
        ],
        staffFunList:{
          cloudSupplierBtnList:[
            {
              name:"销售订单",
              icon:require("../../assets/iconList/order@2x.png"),
              iconChange:require("../../assets/iconList/orderChange@2x.png"),
              func:this.toQueryOrderSeller
            },{
              name:"采购订单",
              icon:require("../../assets/iconList/purchase@2x.png"),
              iconChange:require("../../assets/iconList/purchaseChange@2x.png"),
              func:this.toQueryOrderBuyer
            },{
              name:"仓库管理",
              icon:require("../../assets/iconList/warehouse@2x.png"),
              iconChange:require("../../assets/iconList/warehouseChange@2x.png"),
              func:this.toStoreManage
            },{
              name:"客户资料",
              icon:require("../../assets/iconList/customerInfo@2x.png"),
              iconChange:require("../../assets/iconList/customerInfoChange@2x.png"),
              func:this.toClientManage
            },
          ],
          workShopManageList:[

          ],
          overAllPperationList:[

          ]
        }
			}
		},
		computed: {
      ...mapGetters({
        mode: 'mode',
        staffInfo:'staffInfo'
      }),
      ...mapState({
        mainAcounts:'mainAcounts',
        identityMode:'identityMode',
        saveMyUserInfo:'saveMyUserInfo',
        saveMySupplierInfo:'saveMySupplierInfo',
      }),
      nowManageList(){
        if(this.nowGuiguiFun == '基础办公'){
          if(!this.identityMode){
            return this.cloudSupplierBtnList
          }else{
            return this.staffFunList.cloudSupplierBtnList
          }
          
        }else if(this.nowGuiguiFun == '车间管理'){
          if(!this.identityMode){
            return this.workShopManageList
          }else{
            return this.staffFunList.workShopManageList
          }
        }else if(this.nowGuiguiFun == '全面运营'){
          if(!this.identityMode){
            return this.overAllPperationList
          }else{
            return this.staffFunList.overAllPperationList
          }
        }
      },
      supplierInfo(){
        return this.$store.state.supplierInfo||{
           name:"",
           deposit:0
        }
      },
      supplier_id(){
        if(this.$store.state.supplierInfo){
            return this.$store.state.supplierInfo.id
        }else{
            return 0
        }
      },
      userInfo(){
        return this.$store.state.userInfo
      },
      role(){
          let role = ''
          if(this.mode){
            // 非供应商用户角色
            let edition = this.saveMyUserInfo.edition_id
            if(edition == 1 || edition == 2){
              role = "个人"
            }else if(edition == 3 || edition == 4 || edition == 7){
              role = "门店"
            }else{
              role = "工厂"
            }
          }else{
            if(this.saveMySupplierInfo.identity == 0){
              role= '供应商'
            }else if(this.saveMySupplierInfo.identity == 1){
              role= '分仓'
            }else if(this.saveMySupplierInfo.identity == 2){
              role= '总仓'
            }
          }
          
          return role
      },
      price_count(){
        // console.log(this.supplierInfo.color_price?this.supplierInfo.color_price.split(',').length:0)
        // console.log(this.supplierInfo.base_price?this.supplierInfo.base_price.split(',').length:0)
        // console.log(this.supplierInfo.color_price?this.supplierInfo.color_price.split(',').length:0+(this.supplierInfo.base_price?this.supplierInfo.base_price.split(',').length:0))
        return this.supplierInfo.color_price?this.supplierInfo.color_price.split(',').length:0+(this.supplierInfo.base_price?this.supplierInfo.base_price.split(',').length:0)
      }
		},
		mounted() {

    },
		methods: {
      changeFunNav(item){
        this.nowGuiguiFun = item
      },
      changeImg(e){
        let that=this
        let index=e.currentTarget.dataset.index
        let temp=that.nowManageList[index]
        temp.hover=true
        that.$set(that.nowManageList,index,temp)
      },
      backImg(e){
        let that=this
        let index=e.currentTarget.dataset.index
        let temp=that.nowManageList[index]
        temp.hover=false
        that.$set(that.nowManageList,index,temp)
      },
      toPacking(){
        console.log(window.location)
        // window.open('window.location.protocol' + `//erp.eggi.cn/client.html#/packing?uid=${this.data.id}`)
        window.open(`http://erp.eggi.cn/client.html#/packing?uid=${this.userInfo.id}`)
      },
      toCloudMall(){
        window.open(window.location.origin + '/')
      },
      toDesignOrder(){
        window.open(window.location.origin + '/#/DesignOrder')
      },
      toSupplierManage() {
        const routeData = this.$router.resolve({
          name: 'supplierManage'
        });
        window.open(routeData.href, '_blank');
      },
      toColorCardManage(){
        // 不再限制进入颜色管理
        window.open(window.location.origin + '/#/ColorCardManage')
        // if(this.supplier_id != 0){
        //  /*  this.$router.push(
        //       'ColorCardManage'
        //   ) */
        //   window.open(window.location.origin + '/#/ColorCardManage')
        // }else{
        //   this.$message({
        //       message: '你还不是供应商，无法添加个人颜色！',
        //       duration: '1000'
        //   })
        // }
      },
      toFinancialManage(){
        window.open(window.location.origin + '/#/financialManage')
      },
      toClientManage(){
        // console.log(window.location.origin)
        window.open(window.location.origin + '/#/clientManage')
        // this.$router.push('/clientManage')
        
      },
      dev(){
        this.$message('努力开发中，敬请期待')
        return
        
      },
      toShop(){
        this.$router.push('/'); 
      },
      toProductOrder(){
        window.open(window.location.origin + '/#/ProductOrder')
      },
      toAlbumManage(){
        window.open(window.location.origin + '/#/albumManage')
      },
      toStaffManage(){
        window.open(window.location.origin + '/#/staffManage')
      },
      toVipSystem(){
        window.open(window.location.origin + '/#/vipSystem')
      },
      toQuotation(){
        this.$message('开发中')
      },
      toStoreManage(){
        window.open(window.location.origin + '/#/storeManage')
      },
      toGoodsManage(){
        // this.$emit('changeNow','商品管理')
        // this.$store.commit('changeNavNow','商品管理')
        window.open(window.location.origin + '/#/goodsManage')
      },
      toQueryOrderSeller(){
        // this.$router.push('/QueryOrder')
         window.open(window.location.origin + '/#/QueryOrder/seller')
       /*  this.$router.replace({
            name: 'QueryOrder',
            params: {business: 'seller'}
          }); */
      },
      toQueryOrderBuyer(){
        // this.$router.push('/QueryOrder')
         window.open(window.location.origin + '/#/QueryOrder/buyer')
       /*  this.$router.replace({
            name: 'QueryOrder',
            params: {business: 'seller'}
          }); */
      },
      toShowRoom(){
        window.open(window.location.origin + '/#/showRoom')
      },
      toAdministrator(){
        if(this.userInfo.cloud_manager == 1){
          this.$router.push('./Administrator')
        }else{
          this.$message({
            message: '你不是管理员,无此权限！',
            type: 'warning'
          });
        }

      }
		}
	}
</script>
